import { makeAutoObservable, observable } from "mobx";
import Storage from "utils/storage";
import { get_time } from "api/v4/market";

export enum LayoutEnum {
  classic = "classic", //标准版
  advanced = "advanced", //专业版
  fullscreen = "fullscreen", //全屏版
}

export enum BreakpointEnum {
  xl = "xl", //超大屏幕，以 1698px 做设计，≥ 1698px
  lg = "lg", //正常屏幕，以 1400px 做设计， 1200px < normal < 1698px
  md = "md", //稍小屏幕，以 1020px 做设计， 768px < md ≤ 1200px
  sm = "sm", //移动端屏幕，以 375px 做设计，≤ 768px
}

export enum ClsUpDownEnum {
  up = "up-color", //上涨样式
  down = "down-color", //下跌样式
}
interface StateProps {
  clientSideReady: boolean;
  breakpoint: BreakpointEnum;
  windowInnerWidth: WithUndefined<number>;
  layout: LayoutEnum;
  time: { server: number; local: number };
}

const app = makeAutoObservable(
  {
    clientSideReady: false as StateProps["clientSideReady"], //客户端是否就绪
    breakpoint: BreakpointEnum.lg as StateProps["breakpoint"], //屏幕尺寸断点
    windowInnerWidth: undefined as StateProps["windowInnerWidth"], //屏幕当前内部宽度
    layout: LayoutEnum.advanced as StateProps["layout"], //当前交易视图，标准版=classic，专业版=advanced，全屏版=fullscreen
    time: {
      server: 0, //获取的服务器时间
      local: 0, //获取到服务端时间时，本地的时间戳
    } as StateProps["time"],

    get isH5(): boolean {
      return this.breakpoint === BreakpointEnum.sm;
    }, //是否是H5布局

    updateState(payload: Partial<StateProps>) {
      for (const va in payload) {
        this[va] = payload[va];
      }
    },
    //
    initLayout() {
      this.layout = (() => {
        const layout = Storage.get("layout");
        if (layout && LayoutEnum[layout]) return layout;
        return LayoutEnum.advanced;
      })();
    },
    getServerTime() {
      get_time().then(({ serverTime }) => {
        this.updateState({
          time: {
            server: serverTime as any,
            local: Date.now(),
          },
        });
      });
    },
  },
  {},
  {
    autoBind: true,
    deep: false,
  }
);

export default app;
